import React, { useContext } from 'react'

import { TableContext } from './TableContext'

const BulkSubmitButton = ({ visible }) => {
    const { selectedUploads, bulkSubmit, bulkSubmitLoading } = useContext(
        TableContext
    )
    return (
        <button
            style={{
                visibility: `${visible ? `visible` : `hidden`}`,
            }}
            className={`button is-normal is-link bulkSubmitButton ${
                bulkSubmitLoading ? `is-loading` : ``
            }`}
            disabled={selectedUploads.length === 0 || bulkSubmitLoading}
            onClick={() => bulkSubmit()}
        >
            Submit
        </button>
    )
}

export default BulkSubmitButton
